export const indexTitle = "We deliver organic vegetables & fruits"
export const catagorySubtitle="Protect the health of every home"


export const FrequentlyBrought_title="Our Products"
export const FrequentlyBrought_subtitle="Featured Products"
export const FrequentlyBrought_description="Far far away, behind the word mountains, far from the countries Vokalia and Consonantia"

export const dealSubtitle="Best Price For You"
export const dealTitle="Deal of the day"
export const dealDescription="Far far away, behind the word mountains, far from the countries Vokalia and Consonantia"
export const dealEndMessage="Deal Ends for the day !!"
export const customerReviewSectionTitle="Testimony"
export const customerReviewSectionSubtitle="Our satisfied customer says"
export const customerReviewSectionDescription="Far far away, behind the word mountains, far from the countries Vokalia and Consonantia"

export const customerReviewCarddescription="Far far away, behind the word mountains, far from the countries Vokalia and Consonantia"
export const customerReviewCardname="Garreth Smith"
export const customerReviewCarposition="System Analyst"

//Navbar

export const siteIssue="Currently working on new features, we will start soon!!!"
//footer text

export const footer_aboutTitle="Vegefoods"
export const footer_aboutDescription="Far far away, behind the word mountains, far from the countries Vokalia and Consonantia"

export const footer_deliveryTitle="Delivery Timings"
export const Weekdays="Weekdays"
export const WeekdaysTime="07.00 am - 08.00 pm"
export const WeekEnd="WeekEnds"
export const WeekEndTime="08.00 am - 10.00 pm"

export const footer_contactUsTitle="Contact Us"
export const footer_address="203 Fake St. Mountain View, San Francisco, California, USA"
export const footer_mobileNumber="7869581180"
export const footer_whatsUpmobileNumber="7869581190"

export const footer_copyright="Copyright"
export const footer_2_text1="All rights reserved | This website is made with "


//PDP

export const pdpDescription="Fresh cabbage (Brassica oleracea var. capitata) is a leafy green vegetable belonging to the Brassicaceae family, which also includes other well-known vegetables like broccoli, cauliflower, and kale. Cabbage is renowned for its versatility, crisp texture, and mild, slightly peppery flavor."

export const realtedItemTitle="Realted Items"
export const realtedItemSubTitle="People Who Viewed This Item Also Viewed"


//notify messages
export const itemAddedToCart="Item successfully added to the cart";
export const itemRemoveFromCart="Item successfully remove from the cart";
export const userDetailsUpdated="Your details successfully updated";
export const CouponNotApplyAtThisPrice="Coupon code cannot be apply at this price";
export const invalidCoupon="Invalid Coupon code";
export const paymentDoneOrderPlaced="Your order has been placed successfully";